import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ScrollError extends Vue {
  public scrollError(formElement: HTMLFormElement) {
    Vue.nextTick(() => {
      const element: HTMLElement = formElement.$el
        .querySelector('.el-form-item__error').parentElement;

      // scroll to first input with error
      if (element && element.parentElement) {
        element.parentElement.scrollIntoView();
      }
    });
  }
}
